import { ca } from '@cian/analytics';

export function trackOnboardingShow(id: number | string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Show',
    category: 'StartupOnboarding',
    page: {
      extra: {
        onboarding_id: id,
      },
    },
  });
}

export function trackOnboardingClick(id: number | string, buttonName: string) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'StartupOnboarding',
    page: {
      extra: {
        onboarding_id: id,
        button_name: buttonName,
      },
    },
  });
}

export function trackOnboardingClose(id: number | string, reason: 'button' | 'cross' | 'other') {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Close',
    category: 'StartupOnboarding',
    page: {
      extra: {
        onboarding_id: id,
        close_reason: reason,
      },
    },
  });
}
